import { BackButton } from '../buttons/Buttons';

type Props = {
	title: string;
	subTitle?: string;
	description?: string;
	id: string;
	onBack: () => void;
};

export const Header = (props: Props) => {
	const { onBack, title, description, id } = props;
	return (
		<div className="space-y-2">
			<div>
				<BackButton withIcon label="Back" id={id} onClick={onBack} />
			</div>
			<div className="space-y-2">
				<h1 className="text-headline-large text-neutral17">{title}</h1>
				{description && (
					<p className="text-title-medium font-normal text-xl text-onSurfaceVariant">
						{description}
					</p>
				)}
			</div>
		</div>
	);
};

export const HeaderWithSubtitle = (props: Props) => {
	const { onBack, title, description, subTitle, id } = props;
	return (
		<div className="space-y-3">
			<div>
				<BackButton withIcon label="Back" id={id} onClick={onBack} />
			</div>
			<div className="">
				<p className="text-tertiary text-lg font-normal">{subTitle}</p>
				<h1 className="text-headline-large text-neutral17 mt-1">
					{title}
				</h1>
				{description && (
					<p className="text-body-medium text-neutral17 font-normal mt-2">
						{description}
					</p>
				)}
			</div>
		</div>
	);
};
